import { render, staticRenderFns } from "./TercihlerIlamBilgileri.vue?vue&type=template&id=cd48dfb0&scoped=true"
import script from "./TercihlerIlamBilgileri.vue?vue&type=script&lang=ts"
export * from "./TercihlerIlamBilgileri.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd48dfb0",
  null
  
)

export default component.exports